<nb-card class="card-box">
    <nb-card-header class="content-header">
        <span class="title">{{'common.new-updated-version' | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="close()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body cloud-version-box">
        <div class="cloud-version-box__icon">
            <nb-icon status="primary" icon="checkmark-circle-outline"></nb-icon>
        </div>
        <div class="cloud-version-box__information">
            <span class="cloud-version-box__information__title">{{'common.you-are-using-updated-inCloud-version' | translate}}</span>
            <span class="cloud-version-box__information__caption">
                {{'common.application' | translate}}: <span class="value">inCloud</span>
                {{'common.version' | translate}}: <span class="value">{{version()}}</span>
            </span>
        </div>
    </nb-card-body>
    <nb-card-body class="content-body changelog-box">
        <div class="changelog-box__name">
            {{'common.changelog' | translate}}
        </div>
        <div class="changelog-box__features" *ngFor="let feature of features">
            <span><nb-icon icon="chevron-right-outline"></nb-icon></span>
            <span class="changelog-box__features__text">{{feature}}</span>
        </div>
    </nb-card-body>
    <nb-card-footer class="content-footer">
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" tabindex="-1" (click)="close()">
            {{'common.ok' | translate | uppercase }}
        </button>
    </nb-card-footer>
</nb-card>